var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseBlack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5265 3.23247C16.1512 2.60776 16.1512 1.59324 15.5265 0.96853C14.9018 0.343823 13.8872 0.343823 13.2625 0.96853L8 6.23606L2.73247 0.973528C2.10776 0.348821 1.09324 0.348821 0.46853 0.973528C-0.156177 1.59824 -0.156177 2.61276 0.46853 3.23747L5.73606 8.5L0.473528 13.7675C-0.151179 14.3922 -0.151179 15.4068 0.473528 16.0315C1.09824 16.6562 2.11276 16.6562 2.73747 16.0315L8 10.7639L13.2675 16.0265C13.8922 16.6512 14.9068 16.6512 15.5315 16.0265C16.1562 15.4018 16.1562 14.3872 15.5315 13.7625L10.2639 8.5L15.5265 3.23247Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseBlack);
export default __webpack_public_path__ + "static/media/close_black.189a1759bea49efc7e4f001789141b78.svg";
export { ForwardRef as ReactComponent };